export default __webpack_public_path__ + "961d67294deccae7cc75078cc91ea876.png";